module.exports = __webpack_public_path__ + "static/media/image_69.5dbff495.png";